// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Spinner-module__purple__XjxNb > circle {\n  fill: var(--color-primary);\n}\n\n.Spinner-module__white__EIXX4 > circle {\n  fill: white;\n}\n", "",{"version":3,"sources":["webpack://./src/common/components/Spinner.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb","sourcesContent":[".purple > circle {\n  fill: var(--color-primary);\n}\n\n.white > circle {\n  fill: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"purple": "Spinner-module__purple__XjxNb",
	"white": "Spinner-module__white__EIXX4"
};
export default ___CSS_LOADER_EXPORT___;
